export enum Ability {
  canAccessApp = "GGA_CanAccessApp",
  canManageConstructionSites = "GGA_CanManageConstructionSites",
  canEditConstructionSiteTeams = "GGA_CanEditConstructionSiteTeams",
  canAccessPlanning = "GGA_CanAccessPlanning",
  canApproveTimeEntries = "GGA_CanApproveTimeEntries",
  canManageTimeEntries = "GGA_CanManageTimeEntries",
  canExportTimeEntries = "GGA_CanExportTimeEntries",
  canMonitorActiveTimeEntries = "GGA_CanMonitorActiveTimeEntries",
  canAccessAppStats = "GGA_CanAccessAppStats",
  canAccessAppStatsUsers = "GGA_CanAccessAppStatsUsers",
  canManageTools = "GGA_CanManageTools",
  canAssignTools = "GGA_CanAssignTools",
  canChangeToolManager = "GGA_CanChangeToolManager",
  canExportTools = "GGA_CanExportTools",
  canExportToolAccountingRecords = "GGA_CanExportToolAccountingRecords",
  canExportEmployeeTimeEntries = "GGA_CanExportEmployeeTimeEntries",
  canExportTimeApprovalTimeEntries = "GGA_CanExportTimeApprovalTimeEntries",
  canExportEmployees = "GGA_CanExportEmployees",
  canViewOrganigram = "GGA_CanViewOrganigram",
  canManageOrganigram = "GGA_CanManageOrganigram",
  canManageAbsences = "GGA_CanManageAbsences",
  canViewLeisureAndVacationAbsenceColumns = "GGA_CanViewLeisureAndVacationAbsenceColumns",
  canViewLeisureAndVacationAbsenceColumnsOfEachEmployee = "GGA_CanViewLeisureAndVacationAbsenceColumnsOfEachEmployee",
  canAccessControlling = "GGA_CanAccessControlling",
  canManageSurchargeRate = "GGA_CanManageSurchargeRate",
  canAccessBookedHoursOfEachEmployee = "GGA_CanAccessBookedHoursOfEachEmployee",
  canSynchronizeControllingData = "GGA_CanSynchronizeControllingData",
  canAccessHoursEvaluation = "GGA_CanAccessHoursEvaluation",
  canExportHoursEvaluation = "GGA_CanExportHoursEvaluation",
  canAccessProfitContributionReport = "GGA_CanAccessProfitContributionReport",
  canViewProfitContributionReportGmbh = "GGA_CanViewProfitContributionReportGmbh",
  canViewProfitContributionReportBusinessLine = "GGA_CanViewProfitContributionReportBusinessLine",
  canManageBudget = "GGA_CanManageBudget",
  canAccessWageTypes = "GGA_CanAccessWageTypes",
  canEditCommuteTimes = "GGA_CanEditCommuteTimes",
  canExportBookedHoursOverview = "GGA_CanExportBookedHoursOverview",
  canViewContollingToolCostCenters = "GGA_CanViewControllingToolCostCenters",
  canUseDevTools = "GGA_CanUseDevTools",
  canManageToolDocuments = "GGA_CanManageToolDocuments",
  canDeleteToolDocuments = "GGA_CanDeleteToolDocuments",
  canAccessToolNotes = "GGA_CanAccessToolNotes",
  canChangeToolNotes = "GGA_CanChangeToolNotes",
  canUploadBudget = "GGA_CanUploadBudget",
  canAccessEmployeeAdministration = "GGA_CanAccessEmployeeAdministration",
  canViewToolID = "GGA_CanViewToolID",
  canViewToolHistory = "GGA_CanViewToolHistory",
  canViewToolDocumentHistory = "GGA_CanViewToolDocumentHistory",
  canAccessNominalAccountsOverview = "GGA_CanAccessNominalAccountsOverview",
  canViewNextProjectNumber = "GGA_CanViewNextProjectNumber",
  canAccessToolInventoryView = "GGA_CanAccessToolInventoryView",
  canModifyToolInventory = "GGA_CanModifyToolInventory",
  canEditToolInventory = "GGA_CanEditToolInventory",
  canChangeToolNameplates = "GGA_CanChangeToolNameplates",
  canAccessRevenueReport = "GGA_CanAccessRevenueReport",
  canAccessRevenueReportAllTenants = "GGA_CanAccessRevenueReportAllTenants",
  canAssignPhotoDocumentation = "GGA_CanAssignPhotoDocumentation",
  canCreatePhotoDocumentation = "GGA_CanCreatePhotoDocumentation",
  canCreatePhotoDocumentationForAllWorkPackages = "GGA_CanCreatePhotoDocumentationForAllWorkPackages",
  canDeletePhotoDocumentation = "GGA_CanDeletePhotoDocumentation",
  canDownloadPhotoDocumentation = "GGA_CanDownloadPhotoDocumentation",
  canViewPhotoDocumentation = "GGA_CanViewPhotoDocumentation",
  canViewPhotoDocumentationOfAllConstructionSites = "GGA_CanViewPhotoDocumentationOfAllConstructionSites",
  canAccessMyTimeEntries = "GGA_CanAccessMyTimeEntries",
  canAccessNalEvaluation = "GGA_CanAccessNalEvaluation",
  canOpenNalPeriod = "GGA_CanOpenNalPeriod",
  canViewNalOverview = "GGA_CanViewNalOverview",
  canViewNalManagerView = "GGA_CanViewNalManagerView",
  canViewNalControllingView = "GGA_CanViewNalControllingView",
  canFinalReleaseNalPeriod = "GGA_CanFinalReleaseNalPeriod",
  canManuallyExportNal = "GGA_CanManuallyExportNal",
  canFilterProjectsJournalByTenant = "GGA_CanFilterProjectsJournalByTenant",
}

export const anyAbility = Object.values(Ability);
